var React = require('react');

function SDCPause18N (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M6.5,2.5v13h-3V2.5ZM7.5,1h-5a.5.5,0,0,0-.5.5v15a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V1.5A.5.5,0,0,0,7.5,1Z","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"M14.5,2.5v13h-3V2.5Zm1-1.5h-5a.5.5,0,0,0-.5.5v15a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V1.5A.5.5,0,0,0,15.5,1Z","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCPause18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCPause18N;

SDCPause18N.default = SDCPause18N;
